import * as Yup from 'yup'

const editUserSchema = Yup.object().shape({
  // 🧑 Datos Generales
  firstName: Yup.string()
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.NAME.REQUIRED'),

  paternalLastName: Yup.string()
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.LAST_NAME.REQUIRED'),

  maternalLastName: Yup.string().max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS'),

  email: Yup.string()
    .email('FORM.ERROR_MESSAGE.EMAIL.INCORRECT_FORMAT')
    .min(10, 'FORM.ERROR_MESSAGE.MINIMUM_LENGTH.10_CHARACTERS')
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.EMAIL.REQUIRED'),

  password: Yup.string()
    .min(8, 'FORM.ERROR_MESSAGE.MINIMUM_LENGTH.8_CHARACTERS')
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .matches(/[A-Z]/, 'FORM.PASSWORD_REQUIREMENTS.AT_LEAST_1_UPPERCASE')
    .matches(/[a-z]/, 'FORM.PASSWORD_REQUIREMENTS.AT_LEAST_1_LOWERCASE')
    .matches(/[0-9]/, 'FORM.PASSWORD_REQUIREMENTS.AT_LEAST_1_NUMBER')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'FORM.PASSWORD_REQUIREMENTS.AT_LEAST_1_SPECIAL_CHARACTER')
    .notRequired(),

  // 🧩 Rol y Departamento (como objetos)
  role: Yup.object({
    id: Yup.string().required('FORM.ERROR_MESSAGE.ROLE.REQUIRED'),
  }).required('FORM.ERROR_MESSAGE.ROLE.REQUIRED'),

  department: Yup.object({
    id: Yup.string().required('FORM.ERROR_MESSAGE.DEPARTMENT.REQUIRED'),
  }).required('FORM.ERROR_MESSAGE.DEPARTMENT.REQUIRED'),

  // 🏢 Datos de la Empresa
  companyName: Yup.string()
    .max(100, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.100_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.COMPANY_NAME.REQUIRED'),

  taxId: Yup.string()
    .max(20, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.20_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.TAX_ID.REQUIRED'),

  legalName: Yup.string()
    .max(100, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.100_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.LEGAL_NAME.REQUIRED'),

  fiscalAddress: Yup.string()
    .max(200, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.200_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.FISCAL_ADDRESS.REQUIRED'),

  // 📍 Datos de Ubicación
  address: Yup.string().max(200, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.200_CHARACTERS'),
  city: Yup.string().max(100, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.100_CHARACTERS'),
  state: Yup.string().max(100, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.100_CHARACTERS'),
  country: Yup.string().max(100, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.100_CHARACTERS'),
  postalCode: Yup.string().max(10, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.10_CHARACTERS'),

  // ☎️ Datos de Contacto
  numberPhone: Yup.string().max(20, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.20_CHARACTERS'),
  numberMobile: Yup.string().max(20, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.20_CHARACTERS'),
  fax: Yup.string().max(20, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.20_CHARACTERS'),
  website: Yup.string().test('url', 'FORM.ERROR_MESSAGE.URL.INVALID', (value) => {
    if (!value) return true

    // Solo verifica que tenga un punto y caracteres válidos
    return /^[a-zA-Z0-9][a-zA-Z0-9-_.:/]*\.[a-zA-Z]{2,}$/.test(value)
  }),
})

const updatePasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'FORM.ERROR_MESSAGE.MINIMUM_LENGTH.8_CHARACTERS')
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .matches(/[A-Z]/, 'FORM.ERROR_MESSAGE.AT_LEAST_1_UPPERCASE')
    .matches(/[a-z]/, 'FORM.ERROR_MESSAGE.AT_LEAST_1_LOWERCASE')
    .matches(/[0-9]/, 'FORM.ERROR_MESSAGE.AT_LEAST_1_NUMBER')
    .matches(/[!@#$*]/, 'FORM.ERROR_MESSAGE.AT_LEAST_1_SPECIAL_CHARACTER')
    .required('FORM.ERROR_MESSAGE.PASSWORD.REQUIRED'),
  confirmationPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), undefined], 'FORM.ERROR_MESSAGE.PASSWORD.PASSWORDS_MUST_MATCH')
    .required('FORM.ERROR_MESSAGE.PASSWORD.CONFIRM_PASSWORD_REQUIRED'),
})

const editProductSchema = Yup.object().shape({
  nombre: Yup.string()
    .min(3, 'Minimo 3 caracteres')
    .max(50, 'Maximo 50 caracteres')
    .required('Nombre es obligatorio'),
  sku: Yup.string().min(3, 'Minimo 3 caracteres').max(50, 'Maximo 50 caracteres'),
  //.required('SKU es obligatorio'),
  unit_cost: Yup.number()
    .round('trunc')
    .min(0, 'Puedes ingresar mínimo 0')
    .max(1000000, 'Puedes ingresar máximo S1,000,000.00 USD')
    .required('Precio es obligatorio y numérico'),
  unit_id: Yup.string().url('Ingresa una dirección válida https://example.com'),
  // .required('Hoja de Datos es obligatorio'),
  descripcion: Yup.string().min(10, 'Minimo 10 caracteres').max(300, 'Maximo 300 caracteres'),
  //.required('Descripción es obligatorio'),
})
const editConceptSchema = Yup.object().shape({
  imp_expenses: Yup.number()
    .min(0, 'Puedes ingresar mínimo 0')
    .max(1000000, 'Puedes ingresar máximo 1,000,000.00 USD')
    .required('Precio es obligatorio y numérico'),

  family: Yup.object({
    id: Yup.string().required('Familia es obligatoria'),
    // Puedes agregar más validaciones aquí si necesitas
  })
    .nullable()
    .required('Familia es obligatoria'),

  tipo: Yup.object({
    id: Yup.string().required('Tipo es obligatorio'),
  })
    .nullable()
    .required('Tipo es obligatorio'),

  unit: Yup.object({
    id: Yup.string().required('Unidad es obligatoria'),
  })
    .nullable()
    .required('Unidad es obligatoria'),

  translations: Yup.array()
    .of(
      Yup.object().shape({
        language: Yup.object({
          id: Yup.string().required('Idioma es obligatorio'),
        }).required('Idioma es obligatorio'),
        description: Yup.string()
          .min(1, 'Descripción debe tener al menos 1 caracter')
          .required('Descripción es obligatoria'),
      })
    )
    .min(1, 'Debe haber al menos una traducción'),

  code: Yup.array()
    .of(
      Yup.object().shape({
        department: Yup.object({
          id: Yup.string().required('Departamento es obligatorio'),
        }).required('Departamento es obligatorio'),
        code: Yup.string().min(1, 'Código es obligatorio').required('Código es obligatorio'),
      })
    )
    .min(1, 'Debe haber al menos un código'),
  price: Yup.array()
    .of(
      Yup.object().shape({
        // Validación condicional de brand según la familia
        brand: Yup.object({
          id: Yup.string(),
        }).when('$familyId', {
          is: (familyId: number | string) => {
            const numericFamilyId = Number(familyId)
            // Brand es obligatorio solo para familias 1 y 3
            return [1, 3].includes(numericFamilyId)
          },
          then: (schema) =>
            schema.shape({
              id: Yup.string().required('Marca es obligatoria'),
            }),
          otherwise: (schema) => schema.nullable().notRequired(),
        }),
        unit_cost: Yup.number()
          .min(0, 'Costo mínimo 0')
          .max(1000000, 'Máximo 1,000,000')
          .required('Costo es obligatorio'),
        expire_day: Yup.number()
          .min(1, 'Debe durar al menos 1 día')
          .required('Caducidad es obligatoria'),
        // Campos opcionales que solo aplican para familias 1 y 3
        imported: Yup.boolean(),
        priority: Yup.boolean(),
      })
    )
    .min(1, 'Debe haber al menos un precio'),
})

const editQuotationSchema = Yup.object().shape({
  client: Yup.object()
    .shape({
      id: Yup.string().uuid('El ID del cliente no es válido').required('El cliente es obligatorio'),
    })
    .required('El cliente es obligatorio'),

  project: Yup.object()
    .shape({
      id: Yup.string() // Cambié a string porque veo que tienes '10'
        .required('El proyecto es obligatorio'),
    })
    .required('El proyecto es obligatorio'),

  quotation_review: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.mixed(),
        number_review: Yup.string(),
        created_at: Yup.string(),
        active: Yup.boolean(),
        current_review: Yup.boolean(),
        subtotal: Yup.number().min(0),
        total: Yup.number().min(0),
        shipping: Yup.number().min(0, 'No puede ser negativo').required('Flete es obligatorio'),
        notes: Yup.string().max(500, 'Máximo 500 caracteres'),
        quotation_review_concept: Yup.array()
          .of(
            Yup.object().shape({
              quantity: Yup.number()
                .min(1, 'La cantidad debe ser mayor a 0')
                .required('La cantidad es obligatoria'),
              concept: Yup.object()
                .shape({
                  id: Yup.string()
                    .uuid('El ID de concept no es válido')
                    .required('El ID de concept es obligatorio'),
                })
                .required('Concept es obligatorio'),
            })
          )
          .min(1, 'Debe haber al menos un concepto'),
        quotation_review_indirect_cost: Yup.array().of(
          Yup.object().shape({
            indirect_value: Yup.number()
              .min(0, 'No puede ser negativo')
              .max(1, 'Máximo 1.0')
              .required('El valor indirecto es obligatorio'),
            indirect: Yup.object()
              .shape({
                id: Yup.number().min(1, 'ID inválido').required('El ID de indirect es obligatorio'),
              })
              .required('Indirect es obligatorio'),
          })
        ),
        quotation_review_matrix: Yup.array(),
      })
    )
    .min(1, 'Debe haber al menos una revisión'),
})

const editClientSchema = Yup.object().shape({
  // 🧑 Datos Personales
  firstname: Yup.string()
    .max(50, 'El nombre no puede tener más de 50 caracteres')
    .required('El nombre es obligatorio'),
  paternalLast_name: Yup.string()
    .max(50, 'El apellido paterno no puede tener más de 50 caracteres')
    .required('El apellido paterno es obligatorio'),
  maternalLast_name: Yup.string().max(
    50,
    'El apellido materno no puede tener más de 50 caracteres'
  ),
  email: Yup.string()
    .email('El formato del correo no es válido')
    .max(50, 'El correo no puede tener más de 50 caracteres')
    .required('El correo es obligatorio'),

  // 🏢 Datos Fiscales y de la Empresa
  company_name: Yup.string()
    .max(100, 'El nombre de la compañía no puede exceder los 100 caracteres')
    .required('El nombre de la compañía es obligatorio'),
  tax_id: Yup.string().max(20, 'El RFC/Tax ID no puede exceder los 20 caracteres'),
  // .required('El RFC/Tax ID es obligatorio'),
  legal_name: Yup.string().max(100, 'La razón social no puede exceder los 100 caracteres'),
  // .required('La razón social es obligatoria'),
  fiscal_address: Yup.string().max(200, 'La dirección fiscal no puede exceder los 200 caracteres'),
  // .required('La dirección fiscal es obligatoria'),

  // 📍 Dirección General
  address: Yup.string().max(200, 'La dirección no puede exceder los 200 caracteres'),
  city: Yup.string().max(100, 'La ciudad no puede exceder los 100 caracteres'),
  state: Yup.string().max(100, 'El estado no puede exceder los 100 caracteres'),
  country: Yup.string().max(100, 'El país no puede exceder los 100 caracteres'),
  postalCode: Yup.string().max(10, 'El código postal no puede exceder los 10 caracteres'),

  // ☎️ Datos de Contacto
  phone_number: Yup.string().max(20, 'El teléfono no puede exceder los 20 caracteres'),
  mobile_number: Yup.string().max(20, 'El celular no puede exceder los 20 caracteres'),
  fax: Yup.string().max(20, 'El fax no puede exceder los 20 caracteres'),
  website: Yup.string().test('url', 'FORM.ERROR_MESSAGE.URL.INVALID', (value) => {
    if (!value) return true

    // Solo verifica que tenga un punto y caracteres válidos
    return /^[a-zA-Z0-9][a-zA-Z0-9-_.:/]*\.[a-zA-Z]{2,}$/.test(value)
  }),

  // 🏗️ Proyectos
  projects: Yup.array().of(
    Yup.object()
      .shape({
        name: Yup.string()
          .max(100, 'El nombre del proyecto no puede exceder los 100 caracteres')
          .required('El nombre del proyecto es obligatorio'),
        description: Yup.string().max(500, 'La descripción no puede exceder los 500 caracteres'),
        address: Yup.string().max(200, 'La dirección no puede exceder los 200 caracteres'),
        city: Yup.string().max(100, 'La ciudad no puede exceder los 100 caracteres'),
        state: Yup.string().max(100, 'El estado no puede exceder los 100 caracteres'),
        country: Yup.string().max(100, 'El país no puede exceder los 100 caracteres'),
        postal_code: Yup.string().max(10, 'El código postal no puede exceder los 10 caracteres'),
        project_manager: Yup.string()
          .max(100, 'El nombre del manager no puede exceder los 100 caracteres')
          .required('El manager del proyecto es obligatorio'),
        email_project_manager: Yup.string()
          .email('El correo del manager no es válido')
          .required('El correo del manager es obligatorio'),
        number_phone_project_manager: Yup.string().max(
          20,
          'El teléfono no puede exceder los 20 caracteres'
        ),
        number_mobile_project_manager: Yup.string().max(
          20,
          'El celular no puede exceder los 20 caracteres'
        ),
      })
      .default([])
  ),
})

const familySchema = Yup.object().shape({
  code: Yup.string()
    .required('El código es obligatorio')
    .max(50, 'El código no debe exceder los 50 caracteres'),
  name: Yup.string()
    .required('El nombre es obligatorio')
    .max(100, 'El nombre no debe exceder los 100 caracteres'),
  description: Yup.string()
    .required('La descripción es obligatoria')
    .max(255, 'La descripción no debe exceder los 255 caracteres'),
})

const typeSchema = Yup.object().shape({
  code: Yup.string()
    .required('El código es obligatorio')
    .max(50, 'El código no debe exceder los 50 caracteres'),
  name: Yup.string()
    .required('El nombre es obligatorio')
    .max(100, 'El nombre no debe exceder los 100 caracteres'),
  description: Yup.string()
    .required('La descripción es obligatoria')
    .max(255, 'La descripción no debe exceder los 255 caracteres'),
})

const unitSchema = Yup.object().shape({
  name: Yup.string()
    .required('El nombre es obligatorio')
    .max(100, 'El nombre no debe exceder los 100 caracteres'),
  symbol_sym: Yup.string()
    .required('El símbolo es obligatorio')
    .max(10, 'El símbolo no debe exceder los 10 caracteres'),
  general_type: Yup.string().required('El tipo general es obligatorio'),
})

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('FORM.ERROR_MESSAGE.EMAIL.INCORRECT_FORMAT')
    .min(8, 'FORM.ERROR_MESSAGE.MINIMUM_LENGTH.8_CHARACTERS')
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.EMAIL.REQUIRED'),
  password: Yup.string()
    .min(8, 'FORM.ERROR_MESSAGE.MINIMUM_LENGTH.8_CHARACTERS')
    .max(50, 'FORM.ERROR_MESSAGE.MAXIMUM_LENGTH.50_CHARACTERS')
    .required('FORM.ERROR_MESSAGE.PASSWORD.REQUIRED'),
})

export {
  editUserSchema,
  updatePasswordSchema,
  editProductSchema,
  editQuotationSchema,
  editConceptSchema,
  editClientSchema,
  familySchema,
  typeSchema,
  unitSchema,
  loginSchema,
}
